import React from 'react';
import { motion } from 'framer-motion';

const TechnicalSpecs = () => {
  const detailedSpecs = [
    {
      category: 'Fyzikální parametry',
      color: 'text-accent-teal',
      borderColor: 'border-accent-teal',
      specs: [
        { label: 'Hustota materiálu', value: '483 – 700 kg/m³' },
        { label: 'Ohybová pevnost', value: '7,8 MPa' },
        { label: 'Váha (5mm)', value: '12 – 13 kg' },
        { label: 'Nášlapná vrstva', value: '0,2 – 0,5 mm' }
      ]
    },
    {
      category: 'Materiálové složení',
      color: 'text-brand-500',
      borderColor: 'border-brand-500',
      specs: [
        { label: 'PVC Masterbatch', value: '85 %' },
        { label: 'Resin (Pryskyřice)', value: '7 %' },
        { label: 'Vápenný prášek', value: '5 %' },
        { label: 'Bambusové vlákno', value: '3 %' }
      ]
    },
    {
      category: 'Požární & Teplotní',
      color: 'text-accent-clay',
      borderColor: 'border-accent-clay',
      specs: [
        { label: 'Třída hořlavosti', value: 'B1' },
        { label: 'Testovací stabilita', value: '800 °C' },
        { label: 'Extrémní odolnost', value: '1200 °C' },
        { label: 'Emisní norma', value: 'E0 / ENF' }
      ]
    }
  ];

  return (
    <section id="specs" className="py-32 bg-white dark:bg-dark-bg relative border-b border-arch-border dark:border-dark-border transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <motion.div className="mb-20 text-center" initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} viewport={{ once: true }}>
          <h2 className="text-3xl font-bold text-arch-dark dark:text-white uppercase tracking-widest mb-4">Technická Data</h2>
          <div className="w-16 h-[2px] bg-brand-500 mx-auto"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {detailedSpecs.map((group, idx) => (
            <motion.div 
              key={idx} 
              className="border border-arch-border dark:border-dark-border bg-arch-light dark:bg-dark-surface p-8 relative overflow-hidden"
              initial={{ opacity: 0, y: 30 }} 
              whileInView={{ opacity: 1, y: 0 }} 
              transition={{ delay: idx * 0.1 }}
            >
              <div className={`absolute top-0 left-0 w-full h-1 ${group.color.replace('text-', 'bg-')}`}></div>
              <h3 className={`text-sm font-bold ${group.color} uppercase tracking-widest mb-8 pb-4 border-b border-arch-border dark:border-dark-border`}>
                {group.category}
              </h3>
              <div className="space-y-4">
                {group.specs.map((spec, sIdx) => (
                  <div key={sIdx} className="flex justify-between items-end">
                    <span className="text-arch-gray dark:text-gray-400 text-xs uppercase tracking-wider">{spec.label}</span>
                    <span className="text-arch-dark dark:text-white font-mono text-sm font-bold">{spec.value}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8 border-t border-arch-border dark:border-dark-border pt-16">
          <div className="pr-8 md:border-r border-arch-border dark:border-dark-border">
            <h4 className="text-xs font-bold text-accent-teal uppercase tracking-widest mb-4">01 / Tepelná stabilita</h4>
            <p className="text-arch-gray dark:text-gray-400 text-sm leading-relaxed">
              Materiál neabsorbuje vodu, zabraňuje bobtnání a deformacím. Zcela stabilní po celý rok – v zimě se nesmršťuje a na jaře kvůli vlhkosti nemění tvar.
            </p>
          </div>
          <div className="pl-0 md:pl-8">
            <h4 className="text-xs font-bold text-accent-sage uppercase tracking-widest mb-4">02 / Zpracovatelnost</h4>
            <p className="text-arch-gray dark:text-gray-400 text-sm leading-relaxed">
              Kombinace bambusu a polymerů vytváří strukturu, která drží tvar, ale zároveň absorbuje napětí vznikající při ohýbání za tepla a frézování.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TechnicalSpecs;